import { atom } from "@mongez/react-atom";

type RequestOrderData = {
  customer: {
    name: string;
    email: string;
    phoneNumber: string;
  };
  type: "wedding" | "customized";
  numberOfServings: number;
  size: string;
  filling: string;
  deliveryDate: string;
  pickupDate: string;
  message: string;
  images: string[];
};

export const requestWeddingCakesStepsAtom = atom<number>({
  key: "requestWeddingCakesSteps",
  default: 1,
});

export const requestWeddingCakesDataAtom = atom<RequestOrderData>({
  key: "requestWeddingCakesData",
  default: {},
});

export const requestCustomCakesStepsAtom = atom<number>({
  key: "requestCustomCakesSteps",
  default: 1,
});

export const requestCustomCakesDataAtom = atom<RequestOrderData>({
  key: "requestCustomCakesData",
  default: {},
});
